export const visit = (vm, at) => {
vm(require("./availability/es.lyaml"));
vm(require("./typical-response-time/es.lyaml"));
vm(require("./default/es.lyaml"));
at({ "es": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "Vale" } } });
};